import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-conditions-page',
  templateUrl: './terms-conditions-page.component.html',
  styleUrl: './terms-conditions-page.component.scss',
})
export class TermsConditionsPageComponent {}
